import React, { useEffect, useState, useContext } from "react"
import JoinContext from "../context/join-context"

const AdditionalLegal = () => {
  const res = useContext(JoinContext)

  if (res.state === "OTHER") return null
  if (res.state === "Texas") {
    return (
      <div className="additionalLegal">
        <h3>TEXAS HEALTH AND HUMAN SERVICES WARNING:</h3>
        <p>
          Pornography is potentially biologically addictive, is proven to harm
          human brain development, desensitizes brain reward circuits, increases
          conditioned responses, and weakens brain function.
        </p>
        <p>
          Exposure to this content is associated with low self-esteem and body
          image, eating disorders, impaired brain development, and other
          emotional and mental illnesses.
        </p>
        <p>
          Pornography increases the demand for prostitution, child exploitation,
          and child pornography.
        </p>
      </div>
    )
  }
  if (res.state === "Alabama") {
    return (
      <div className="additionalLegal">
        <h3>ALABAMA HEALTH AND HUMAN SERVICES WARNING</h3>
        <p>
          Pornography is potentially biologically addictive, is proven to harm
          human brain development, desensitizes brain reward circuits, increases
          conditioned responses, and weakens brain function.
        </p>
        <p>
          Exposure to this content is associated with low self-esteem and body
          image, eating disorders, impaired brain development, and other
          emotional and mental illnesses.
        </p>
        <p>
          Pornography increases the demand for prostitution, child exploitation,
          and child pornography.
        </p>
      </div>
    )
  }
}

export default AdditionalLegal
